import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import Link from "../UI/Link/Link"
import * as style from "./GlobalNewsSection-tw-styles"
import useScreenSize from "../../hooks/useScreenSize"
import Slider from "react-slick"
import { getNewsDetails } from "../../service/NewsService"

const GlobalNewsSection = props => {
  const { heading, seeMoreLink, variant } = props
  const screen = useScreenSize()
  const [cardArr, setcardArr] = useState([])

  const settings = {
    arrows: false,
    centerMode: false,
    pauseOnFocus: true,
    autoplaySpeed: 3000,

    speed: 1000,
    slidesToShow: 2.1,
    slidesToScroll: 1,
    focusOnSelect: true,
    autoplay: true,
  }

  const styles = style[variant] || style.defaultStyle

  useEffect(() => {
    const fetchNewsCardsCollection = async () => {
      let data = await getNewsDetails()
      setcardArr(data.slice(0, 4))
    }
    fetchNewsCardsCollection()
  }, [])
  const NewsCardSection = () => {
    return (
      cardArr?.length > 0 &&
      cardArr?.map((item, index) => {
        const date = new Date(item.createdOnUTC).toLocaleString([], {
          day: "2-digit",
          month: "long",
          year: "numeric",
          weekday: "long",
        })
        return (
          <div className={styles?.Content} key={index}>
            {item?.link?.hostedUrl && (
              <>
              <p className={styles?.Content2}>{date}</p>
              <Link ariaLabel={item?.title} url={item?.link?.hostedUrl} gaEventLabel={item?.title}>
                
                <p className={styles?.Para3}>{item?.title}</p>
              </Link>
              </>
            )}
          </div>
        )
      })
    )
  }

  return (
    <div className={styles?.ContentContainer}>
      {heading && (
        <div>
          <h2 className={styles?.Container}>{heading}</h2>
        </div>
      )}
      {screen && screen.isMobile ? (
        <>
          <div className={styles?.Heading}>
            <Slider {...settings} className={styles?.HeadingOne}>
              {NewsCardSection()}
            </Slider>
          </div>
        </>
      ) : (
        <>
          <div className={styles?.Heading}>{NewsCardSection()}</div>
        </>
      )}
      <div className={styles?.Button}>
        {seeMoreLink && (
          <div className={styles?.Button2}>
            <Link  {...seeMoreLink} url={seeMoreLink?.url}>{seeMoreLink?.label}</Link>
          </div>
        )}
      </div>
    </div>
  )
}

GlobalNewsSection.propTypes = {
  heading: PropTypes.string,
  newsCardsCollection: PropTypes.object,
  seeMoreLink: PropTypes.object,
  variant: PropTypes.string,
}

export default GlobalNewsSection
